// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Page_wrapper__3YNJH","bannerActive":"Page_bannerActive__1WdpA","childContent":"Page_childContent__3eu8r"};